import { useEffect } from "react";

import { Stack, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { HowdyGoEmbeddedDemo } from "components/HowdyGoEmbeddedDemo";
import { useSubscriptionStatus } from "hooks";
import { PageLayout } from "layouts";

import type { ClientAppEvent } from "constants/index";

const UPGRADE_HEADLINE =
  "The following is demo data. Upgrade your plan to access live analytics data.";

interface HowdyGoDemoPageProps {
  publicationId: string;
  event: ClientAppEvent;
  visitedUrl: string;
  demoHeadline: string;
  isDemoParticipant?: boolean;
}

export function HowdyGoDemoPage(props: HowdyGoDemoPageProps) {
  const {
    publicationId,
    event,
    visitedUrl,
    demoHeadline,
    isDemoParticipant = false,
  } = props;
  const posthog = usePostHog();
  const { subscription } = useSubscriptionStatus();

  useEffect(() => {
    posthog?.capture(event, {
      subscription_plan: subscription?.subscription_plan ?? undefined,
      howdygo_publication_id: publicationId,
      visited_url: visitedUrl,
      is_demo_participant: isDemoParticipant,
    });
  }, [
    posthog,
    subscription,
    event,
    publicationId,
    visitedUrl,
    isDemoParticipant,
  ]);

  return (
    <PageLayout>
      <Stack textAlign="center" justifyContent="center" alignItems="center">
        <Typography textAlign="center" variant="h6" sx={{ mb: 2 }}>
          {isDemoParticipant ? demoHeadline : UPGRADE_HEADLINE}
        </Typography>
      </Stack>
      <HowdyGoEmbeddedDemo publicationId={publicationId} />
    </PageLayout>
  );
}
